import { t } from "@/i18n-js/instance";

export const getButtonText = (
  couponCode: string | null,
  localeScope: string,
): string => {
  if (couponCode) {
    return t(`${localeScope}.form.buttons.promotion_submit`);
  }

  return t(`${localeScope}.form.buttons.submit`);
};
